<template>
  <v-row
    no-gutters
    class="justify-center"
  >
    <v-col
      cols="9"
      sm="8"
      md="6"
    >
      <v-text-field
        v-model="url"
        outlined
        disabled
        hide-details
        label="Contactless URL"
        style="border-radius: 0"
      />
    </v-col>
    <v-col
      cols="1"
    >
      <v-btn
        height="56"
        tile
        x-large
        block
        class="elevation-0"
        color="success"
        dark
        @click="copy()"
      >
        Copy
      </v-btn>
      <input
        id="myInput"
        type="text"
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Copy",
  props: {
    storeId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      url: `${this.DINER_APP_URL}?store=${this.storeId}&table=table_name`
    };
  },
  methods: {
    copy() {
      var copyText = document.getElementById("myInput");
      copyText.value = this.url;
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      copyText.value = "";
      document.getElementById("myInput").blur();

      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: "Contactless URL copied",
        color: "success"
      });
    }
  }
};
</script>